import { SITE_URL, localeHomeUrl } from '../constants/siteSeo';
import { homeCanonicalSegment } from './publicAccessPaths';

/** トップの言語別 canonical URL（引用・JSON-LD 用） */
export function homeCitationUrl(pathname: string): string {
  const segment = homeCanonicalSegment(pathname);
  if (segment) {
    return localeHomeUrl(segment);
  }
  return `${SITE_URL}/`;
}

export function buildHomeCitationSnippet(snippetText: string, pathname: string): string {
  const trimmed = snippetText.trimEnd();
  return `${trimmed} ${homeCitationUrl(pathname)}`;
}
